import React, {Component} from 'react';

import { Table } from 'react-bootstrap';
import Modal from '../../../../components/Modal';

import './index.css';

class Popup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: props.stats.sort(this.sortByCCAsc),
            sort: {
                by: 'CC',
                order: 1
            }
        };
    }

    handleSort(param) {
        const { stats, sort } = this.state;

        sort.order = sort.by != param ? 1 : -sort.order;
        sort.by = param;

        const sortOrder = sort.order == 1 ? 'Asc' : 'Desc';

        this.setState({
            stats: stats.sort(this[`sortBy${sort.by}${sortOrder}`]),
            sort
        });
    }

    sortByCCAsc(a, b) {
        if(a.cc < b.cc) return -1;
        if(a.cc > b.cc) return 1;
        return 0;
    }

    sortByCCDesc(a, b) {
        if(a.cc > b.cc) return -1;
        if(a.cc < b.cc) return 1;
        return 0;
    }

    sortByUsersAsc(a, b) {
        if(a.users < b.users) return -1;
        if(a.users > b.users) return 1;
        return 0;
    }

    sortByUsersDesc(a, b) {
        if(a.users > b.users) return -1;
        if(a.users < b.users) return 1;
        return 0;
    }

    render() {
        const { onHide, stats } = this.props,
            rows = stats.map(({cc, users}) => {
                if(cc === null) return;

                return (
                    <tr key={cc}>
                        <td>{cc}</td>
                        <td>{users}</td>
                    </tr>
                );
            });

        return (
            <Modal onHide={onHide}>
                <div className="users-changes-popup">
                    <Table bordered responsive>
                        <thead>
                        <tr>
                            <th onClick={() => this.handleSort('CC')}>Country</th>
                            <th onClick={() => this.handleSort('Users')}>Users</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </Table>
                </div>
            </Modal>
        );
    }
}

export default Popup;


// WEBPACK FOOTER //
// ./src/scenes/UsersChanges/components/Popup/index.js